import { Link } from "react-router-dom";

const categories = [
  { label: "电视剧", icon: "ri-tv-2-line", to: "/category?type=电视剧" },
  { label: "电影", icon: "ri-movie-line", to: "/category?type=电影" },
  { label: "爱情", icon: "ri-heart-3-line", to: "/category?genre=爱情" },
  { label: "喜剧", icon: "ri-emotion-laugh-line", to: "/category?genre=喜剧" },
  { label: "悬疑", icon: "ri-question-line", to: "/category?genre=悬疑" },
  { label: "科幻", icon: "ri-planet-line", to: "/category?genre=科幻" },
  { label: "武侠", icon: "ri-sword-line", to: "/category?genre=武侠" },
  { label: "家庭", icon: "ri-home-heart-line", to: "/category?genre=家庭" },
];

export default function CategoryQuickNav() {
  return (
    <section className="px-4 md:px-6 py-12 md:py-16">
      <div className="flex items-end justify-between gap-4 mb-6">
        <div>
          <h2 className="font-heading font-semibold text-2xl md:text-3xl text-foreground-950">
            影视分类快捷入口
          </h2>
          <p className="mt-1.5 text-sm text-foreground-600">
            按类型与题材快速找到感兴趣的影视内容
          </p>
        </div>
        <Link
          to="/category"
          className="hidden sm:inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap"
        >
          全部分类
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-3 md:gap-4">
        {categories.map((item) => (
          <Link
            key={item.label}
            to={item.to}
            className="group flex flex-col items-center gap-3 py-5 md:py-6 rounded-lg bg-background-100 border border-background-200/70 hover:border-primary-300 transition-colors duration-300 cursor-pointer"
          >
            <span className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors duration-300">
              <i className={`${item.icon} text-xl md:text-2xl`}></i>
            </span>
            <span className="font-heading text-sm md:text-base text-foreground-800">
              {item.label}
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}